import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SourceType } from '../../../Models/configuration-options/source-type';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'server-side-lookup-options',
    templateUrl: './server-side-lookup-options.component.html',
    styleUrls: ['./server-side-lookup-options.component.less'],
    imports: [MatCard, MatCardTitle, MatCardContent, MatCheckbox, FormsModule]
})
export class ServerSideLookupOptions implements OnInit {
  @Input() failValidationOnFailedLookup: boolean;
  @Input() publishAnywayOnFailedLookup: boolean;
  @Input() allowMappingAfterFirstSave: boolean;
  @Input() sourceType: SourceType;

  @Output() failValidationOnFailedLookupChange = new EventEmitter<boolean>();
  @Output() publishAnywayOnFailedLookupChange = new EventEmitter<boolean>();
  @Output() allowMappingAfterFirstSaveChange = new EventEmitter<boolean>();

  ngOnInit(): void {
    if (this.failValidationOnFailedLookup === undefined || this.failValidationOnFailedLookup === null) {
      this.failValidationOnFailedLookup = false;
    }

    if (this.publishAnywayOnFailedLookup === undefined || this.publishAnywayOnFailedLookup === null) {
      this.publishAnywayOnFailedLookup = false;
    }

    if (this.allowMappingAfterFirstSave === undefined || this.allowMappingAfterFirstSave === null) {
      this.allowMappingAfterFirstSave = false;
    }
  }

  setFailValidationOnFailedLookup(): void {
    this.failValidationOnFailedLookupChange.emit(this.failValidationOnFailedLookup);
  }

  setPublishAnywayOnFailedLookup(): void {
    this.publishAnywayOnFailedLookupChange.emit(this.publishAnywayOnFailedLookup);
  }

  setAllowMappingAfterFirstSave(): void {
    this.allowMappingAfterFirstSaveChange.emit(this.allowMappingAfterFirstSave);
  }
}
